import React, { useCallback } from 'react';

const Sort = ({ sortingType, isAsc, isDesc, onUpdateSorting }) => {
  const handleAsc = useCallback(() => onUpdateSorting('asc'), [onUpdateSorting]);
  const handleDesc = useCallback(() => onUpdateSorting('desc'), [onUpdateSorting]);

  return (
    <div className="sortByContainer">
      <h4>Sort by</h4>
      {sortingType === 'alphabetical' && (
        <div className="sortingItems">
          <a className={`sortingItem ${isAsc ? 'active' : ''}`} onClick={handleAsc}>
            Ascending (A-Z) <i className="material-icons">check</i>
          </a>
          <a className={`sortingItem ${isDesc ? 'active' : ''}`} onClick={handleDesc}>
            Descending (Z-A) <i className="material-icons">check</i>
          </a>
        </div>
      )}
      {sortingType === 'chronological' && (
        <div className="sortingItems">
          <div className="sortingItems">
            <a className={`sortingItem ${isAsc ? 'active' : ''}`} onClick={handleAsc}>
              Ascending (Oldest - Newest) <i className="material-icons">check</i>
            </a>
            <a className={`sortingItem ${isDesc ? 'active' : ''}`} onClick={handleDesc}>
              Descending (Newest - Oldest) <i className="material-icons">check</i>
            </a>
          </div>
        </div>
      )}
      {sortingType === 'numerical' && (
        <div className="sortingItems withSortIcon">
          <div className="sortingItems withSortIcon">
            <a className={`sortingItem ${isAsc ? 'active' : ''}`} onClick={handleAsc}>
              <i className="material-icons sortIcon">arrow_upward</i>
              Ascending (Least - Greatest)
            </a>
            <a className={`sortingItem ${isDesc ? 'active' : ''}`} onClick={handleDesc}>
              <i className="material-icons sortIcon">arrow_downward</i>
              Descending (Greatest - Least)
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sort;
